import React, { FC } from 'react';

import { ListCardGroup } from 'components/list-card-group';
import { useModifierRedesignExperiment } from 'experiments/use-modifier-redesign-phase-one';
import { t } from 'state/intl/translations';

import { Modifier } from '../modifier';
import { ModifierExperiment } from '../modifier/experiment/modifier';
import { IModifierData } from '../modifier/types';

import { IModifierGroupProps } from './types';

export const ModifierGroup: FC<IModifierGroupProps> = ({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
  selectedItem,
}) => {
  const enableModifierRedesign = useModifierRedesignExperiment();
  const ModifierComponent = enableModifierRedesign ? ModifierExperiment : Modifier;

  return (
    <ListCardGroup
      items={modifiers}
      header={displayGroupName !== 'chooseItemAmount' ? t(displayGroupName) : undefined}
      renderItem={({ item: modifierProps }: { item: IModifierData }) => {
        return (
          <ModifierComponent
            key={`modifier-${modifierProps.modifier.name?.locale}`}
            {...modifierProps}
            onSelectionsChange={selections =>
              onModifierSelectionChange(selections, modifierProps.modifier)
            }
            selectedItem={selectedItem}
          />
        );
      }}
    />
  );
};
